import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const MultiselectOption = ({ onChange, checked, label }) => (
  <div className={cx('c-multiselect-option', { 'is-active': checked })}>
    <label className="c-multiselect-option__label">
      <input
        className="c-multiselect-option__input"
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
      />
      <span className="c-multiselect-option__trigger" />
      <span className="c-multiselect-option__text">{label}</span>
    </label>
  </div>
);

MultiselectOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};

export default MultiselectOption;
